import React from 'react'

function Experience() {
  return (
    <div className="b-container TechCard mt-5">
      <h2 className="jumbo-2">Experience</h2>
      <ul className="timeline timeline-centered">
        <li className="timeline-item">
          <div className="timeline-info">
            <span>Jan 2025 - Present </span>
          </div>
          <div className="timeline-marker"></div>
          <div className="timeline-content">
            <h3 className="timeline-title">
              Senior Software Engineer, Arcesium India Pvt. Ltd.
            </h3>
            <div style={{ textAlign: 'left' }}>
              <ul>
                <li>
                  Subject Matter Expert for UI development, leading feature
                  enhancements and code reviews.
                </li>
                <li>
                  Configured GitLab pipelines for automated deployments and npm
                  publishing.
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li className="timeline-item">
          <div className="timeline-info">
            <span>July 2023 - Jan 2025 </span>
          </div>
          <div className="timeline-marker"></div>
          <div className="timeline-content">
            <h3 className="timeline-title">
              Software Engineer, Arcesium India Pvt. Ltd.
            </h3>
            <div style={{ textAlign: 'left' }}>
              <ul>
                <li>
                  Designed and implemented an in-platform communication tool
                  with:
                  <div style={{ textAlign: 'left' }}>
                    <ul>
                      <li>
                        Tech-agnostic, embeddable widget using web-components,
                        published on npm.
                      </li>
                      <li>
                        Desktop Notifications with service workers and webhooks.
                      </li>
                    </ul>
                  </div>
                </li>
                <li>
                  Developed Kotlin microservices for communication workflows in
                  Kotlin.
                </li>
                <li>
                  Optimized performance with in-memory caching and AWS SNS based
                  cache refresh across replicas.
                </li>
                <li>
                  Automated Ops workflows with a Chrome extension, reducing
                  manual effort and errors.
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li className="timeline-item">
          <div className="timeline-info">
            <span>May 2022 - Jul 2022 </span>
          </div>
          <div className="timeline-marker"></div>
          <div className="timeline-content">
            <h3 className="timeline-title">
              Software Engineer Intern, Arcesium India Pvt. Ltd.
            </h3>
            <div style={{ textAlign: 'left' }}>
              <ul>
                <li>
                  Implemented a Sanity Checks dashboard and its REST APIs,
                  reducing developers' work by 42 hours per annum in ticket
                  resolution.
                </li>
                <li>
                  Identified and resolved a potential security risk on UI side
                  in an existing application.
                </li>
                <li>[Tech - React, Mobx, Typescript, Kotlin, SQL, MyBatis]</li>
              </ul>
            </div>
          </div>
        </li>
        {/* <li className="timeline-item">
          <div className="timeline-info">
            <span>Jul 2021 - Jul 2022</span>
          </div>
          <div className="timeline-marker"></div>
          <div className="timeline-content">
            <h3 className="timeline-title">
              Technical Lead - Computer Society Of India, COEP Student Chapter
            </h3>
            <p>
              Maintaining the website for CSI, one of the largest technical
              student chapters at COEP.
            </p>
          </div>
        </li> */}
        <li className="timeline-item">
          <div className="timeline-info">
            <span>Jun 2021 - Jun 2022</span>
          </div>
          <div className="timeline-marker"></div>
          <div className="timeline-content">
            <h3 className="timeline-title">Web Head - Mindspark, COEP</h3>
            <div style={{ textAlign: 'left' }}>
              <ul>
                <li>
                  Built the website for MindSpark'21, COEP's annual National
                  Level Technical Fest, that had around 86,000 hits during the
                  fest.
                </li>
                <li>
                  Lead a team of 20 coordinators and coordinated with 26 other
                  core team members for the smooth functioning of the fest.
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li className="timeline-item">
          <div className="timeline-info">
            <span>Jul 2020 - Present</span>
          </div>
          <div className="timeline-marker"></div>
          <div className="timeline-content">
            <h3 className="timeline-title">
              Software Developer - Software Development Section, COEP
            </h3>
            <div style={{ textAlign: 'left' }}>
              <ul>
                <li>
                  Contributed to various projects (most of them on MERN stack).
                  A few of them are - CirQuip, Quiz Maker, Enbuild-Construction
                  App.
                </li>
                <li>
                  Awarded for contribution in Gathering's pass distribution
                  application.
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li className="timeline-item">
          <div className="timeline-info">
            <span>Jan 2021 - Jan 2022</span>
          </div>
          <div className="timeline-marker"></div>
          <div className="timeline-content">
            <h3 className="timeline-title">Web Team Member - ASCI, COEP</h3>
            <div style={{ textAlign: 'left' }}>
              <ul>
                <li>
                  Worked on revamping the website of a major technical club at
                  COEP.
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>
  )
}

export default Experience
